import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/utils';

/** Pictogram stroke on the frosted navy glass — set on the SVG, not inherited. */
export const INTRANET_HERO_ICON_COLOR = '#ffffff';

export function IntranetHeroIconButton({
  children,
  className,
  ...props
}: {
  children: ReactNode;
  className?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      className={cn(
        'inline-flex size-11 shrink-0 items-center justify-center rounded-full',
        'border border-white/35 bg-brand-navy/40 text-white shadow-sm backdrop-blur-md',
        'hover:bg-brand-navy/55 focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
